export const COVERAGE_STATUS = {
  PROVIDED: 'PROVIDED',
  DENIED: 'DENIED',
  NOTICE_ONLY: 'NOTICE ONLY',
  PENDING: 'PENDING',
  PROVIDED_IN_PART_OR_DENIED_IN_PART: 'PROVIDED IN PART OR DENIED IN PART',
} as const;

export type CoverageStatus =
  (typeof COVERAGE_STATUS)[keyof typeof COVERAGE_STATUS];
